/**
 * PowersureFAQSection — dark premium FAQ voor landing en rapport.
 *
 * 7 standaardvragen die het Powersure-product duidelijk maken vóór de
 * intake. Eén component, herbruikbaar op landing + rapport.
 */
import PowersureCard from '@/components/powersure-ui/PowersureCard';
import SectionHeader from '@/components/powersure-ui/SectionHeader';
import FAQAccordion from '@/components/powersure-ui/FAQAccordion';
import { HelpCircle } from 'lucide-react';

const FAQ_ITEMS = [
  {
    id: 'start-without-devices',
    q: 'Moet ik al apparaten koppelen om te starten?',
    a: 'Nee. U kunt direct starten en Mijn Powersure laat eerst voorbeeld-overzichten zien. Apparaten koppelen maakt het advies later persoonlijker en accurater.',
  },
  {
    id: 'auto-control',
    q: 'Kan Powersure mijn apparaten automatisch aansturen?',
    a: 'We starten altijd veilig met inzicht en advies. Sturing komt alleen waar dat technisch ondersteund is, getest is, én door u zelf is goedgekeurd.',
  },
  {
    id: 'price',
    q: 'Wat kost Powersure?',
    a: '€ 9,95 per maand voor de eerste 3 maanden, daarna € 14,95 per maand. Maandelijks opzegbaar. Betalen met creditcard.',
  },
  {
    id: 'installer',
    q: 'Heb ik een installateur nodig?',
    a: 'Niet om te starten. Voor meterkast-aanpassingen, een laadpaal, noodstroom of vaste installaties kan een installateur nodig zijn — we wijzen u dan op de juiste partij.',
  },
  {
    id: 'compatibility',
    q: 'Werkt dit met HomeWizard, Homey of de slimme meter?',
    a: 'Ja. Powersure ondersteunt routes voor de slimme meter (P1), HomeWizard, Homey / Home Assistant en handmatige invoer. Beschikbaarheid hangt af van uw apparaat.',
  },
  {
    id: 'data',
    q: 'Wat gebeurt er met mijn data?',
    a: 'Uw data wordt alleen gebruikt om uw eigen advies en status te verbeteren. Geen onnodige technische rommel, geen verkoop aan derden.',
  },
  {
    id: 'cancel',
    q: 'Kan ik opzeggen?',
    a: 'Ja. Het abonnement is maandelijks opzegbaar via uw account.',
  },
];

export default function PowersureFAQSection({ className = '', testId = 'ps-landing-faq' }) {
  return (
    <section
      className={`container mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 ${className}`}
      data-testid={testId}
    >
      <PowersureCard padding="p-5 sm:p-8" className="max-w-3xl mx-auto">
        <SectionHeader
          label="Veelgestelde vragen"
          title="Belangrijkste vragen, kort beantwoord"
          subtitle="Geen juridische muur tekst — alleen wat u écht wilt weten voordat u start."
          Icon={HelpCircle}
        />
        <div className="mt-5">
          <FAQAccordion items={FAQ_ITEMS} testId={`${testId}-acc`} />
        </div>
      </PowersureCard>
    </section>
  );
}
